import QRCode from "../../../api/qr-code/QRCode";
import {ReactNode, useEffect, useState} from "react";
import Notifications from "../../../utils/notifications/Notifications";
import QRCodeApi from "../../../api/qr-code/QRCodeApi";
import EditQRCodeContext from "./EditQRCodeContext";
import VCardEditForm from "./vcard-edit-form/VCardEditForm";
import NoForm from "./NoForm";
import AnimateIn from "../../../utils/animations/AnimateIn";
import {Container, Title} from "@mantine/core";
import {WebsiteEditForm} from "./WebsiteEditForm";
import {PDFEditForm} from "./PDFEditForm";
import {ImageEditForm} from "./ImageEditForm";

type Props = {
    id?: string | number;
}

function EditQRCode(props: Props) {
    /**
     * QRCode to edit.
     * @author Kacper Faber
     * @since 0.2.0
     */
    const [qrCode, setQRCode] = useState<QRCode>();

    /**
     * On reload success, we need to update QRCode state.
     * @author Kacper Faber
     * @since 0.2.0
     */
    const onReloadSuccess = (qrCode: QRCode) => {
        setQRCode(
            qrCode
        );
    };

    /**
     * On reload failed - show fetch error from standard notifications.
     * @author Kacper Faber
     * @since 0.2.0
     */
    const onReloadFailed = () => {
        Notifications.onFetchError();
    };

    /**
     * Reload the data in context.
     * @author Kacper Faber
     * @since 0.2.0
     */
    const reload = () => {
        if (!props.id) {
            return;
        }

        QRCodeApi.getById(props.id)
            .then(onReloadSuccess)
            .catch(onReloadFailed);
    };

    /**
     * Wraps given children inside an EditQRCodeContext.
     * @author Kacper Faber
     * @since 0.2.0
     */
    const wrapContext = (r: ReactNode | ReactNode[]) => {
        return (
            <EditQRCodeContext.Provider
                children={r}
                value={{ qrCode }}
            />
        );
    };

    const renderEditForm = () => {
        if (!qrCode) {
            return (
                <></>
            );
        }

        if (qrCode.kind === 'vcard') {
            return (
                <VCardEditForm/>
            );
        }

        else if (qrCode.kind === 'website') {
            return (
                <WebsiteEditForm/>
            );
        }

        else if (qrCode.kind === "pdf") {
            return (
                <PDFEditForm/>
            );
        }

        else if (qrCode.kind === "image") {
            return (
                <ImageEditForm/>
            )
        }

        else {
            return (
                <NoForm/>
            );
        }
    };

    useEffect(reload, [props.id]);

    return wrapContext(
        <div>
            <Title order={2}>
                Edycja kodu QR
            </Title>

            <AnimateIn>
                <Container mt="xl">
                    { renderEditForm() }
                </Container>
            </AnimateIn>
        </div>
    );
}

export default EditQRCode;